<template>
  <div v-if="$store.getters.webviewGuard === false">
    <template v-if="$store.getters.popularProducts.items.length !== 0">
      <PopularProducts/>
    </template>
    <template v-if="$store.getters.categories.length !== 0">
      <CategoriesPreview/>
    </template>
    <Basket :page="'home'"/>
    <div style="padding-bottom: 85px;"></div>
  </div>
</template>

<script>
  import {FETCH_PRODUCTS} from '@/store/actions.type'
  import Basket from '@/components/Default/Basket'
  import PopularProducts from '@/components/ECommerce/Products/PopularProducts'
  import CategoriesPreview from '@/components/ECommerce/Categories/CategoriesPreview'
  import {SET_MODAL, SET_SELECTED_CATEGORY, SET_WEBVIEW_GUARD} from '@/store/mutations.type'

  export default {
    name: 'Home',
    data() {
      return {
        FETCH_PRODUCTS
      }
    },
    components: {
      CategoriesPreview,
      PopularProducts,
      Basket
    },
    methods: {},
    computed: {
      categories() {
        let categories = []
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].level === 0 && this.$store.getters.categories[i].id !== null) {
            categories.push(this.$store.getters.categories[i])
          }
        }
        return categories
      }
    },
    mounted() {
    },
    watch: {
      '$route': {
        handler: async function (route) {

          if (route.name === 'home') {
            if (this.$store.getters.isBookingMode && this.$store.getters.guardOutlets.length <= 1) {
              this.$router.push({ name: 'booking' })
              return
            }
            if (this.$store.getters.outlet && (this.$store.getters.outlet.slider.cards.length === 0 && this.categories.length === 1)) {
              await this.$store.commit(SET_SELECTED_CATEGORY, this.categories[0])
              await this.$router.push({name: 'catalog', params: {token: this.$store.getters.token}})
              if (this.$store.getters.modal.search) {
                this.$store.commit(SET_MODAL, {modal: 'search', status: false})
                this.$store.commit(SET_MODAL, {modal: 'searchFull', status: false})
              }
            }
          }
        },
        deep: true,
        immediate: true
      }
    }
  }
</script>
